import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Reset(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M16.964 2.257a.75.75 0 01.639.847l-.56 4.01a.75.75 0 01-.84.64l-4.2-.544a.75.75 0 01.193-1.488l2.539.329C13.606 4.763 11.905 3.954 10 3.954c-3.457 0-6.25 2.743-6.25 6.046a.75.75 0 11-1.5 0c0-4.173 3.507-7.546 7.75-7.546 2.31 0 4.406.973 5.821 2.56l.296-2.118a.75.75 0 01.847-.639zM17.75 10a.75.75 0 00-1.5 0c0 3.303-2.793 6.046-6.25 6.046-1.905 0-3.606-.809-4.734-2.097l2.538.329a.75.75 0 10.192-1.488l-4.2-.544a.75.75 0 00-.839.64l-.56 4.01a.75.75 0 101.486.208l.296-2.12c1.414 1.59 3.511 2.563 5.821 2.563 4.243 0 7.75-3.373 7.75-7.546z"
  }));
}

export { Reset };
//# sourceMappingURL=Reset.js.map